export interface UpdateImage {
  id: string
  thumbnailUrl: string
  fullUrl: string
  width: number
  height: number
  status: string
}

export interface UploadedImage {
  id: string
  thumbnailUrl: string
  fullUrl: string
  width: number
  height: number
  status: string
}

export interface ImageUploadProgress {
  file: File
  progress: number
  status: 'pending' | 'uploading' | 'done' | 'error'
  error?: string
  image?: UploadedImage
}

export const MAX_IMAGES_PER_UPDATE = 5
export const MAX_FILE_SIZE_MB = 10
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024
export const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/heic', 'image/heif']
